module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img4.9654f6a8f300dd2c9b5df105169dae16.jpg";